export default __webpack_public_path__ + "static/media/GenericLogsFromS3.3a752c2b.md";